import { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import MarkCompleted from "../../components/Model/MarkCompleted";
import CancelReason from "../../components/Model/CancelReason";
import { useDispatch, useSelector } from "react-redux";
import {
  DashboardBookingChangeUpdateAction,
  DashboardBookingViewDetailAction,
} from "../../redux/Action/DashboardAction";
import { useLocation } from "react-router-dom";
import {
  LocalFormat,
  LocalTimeFormat,
  UTCFormat,
  capitalizeFirstLetter,
  decodeID,
  formatTimeMinutes,
  getAgeFromDOB,
  getLastURL,
  localTimezone,
  sidebarOpen,
} from "../../utils/Helper";
import { ImageContainer } from "../../constants/ImagesConstants";
import moment from "moment";
import Spinner from "../../components/Spinner";
import ReactTooltip from "react-tooltip";
import { FormattedMessage } from "react-intl";
import Button from "../../components/Ui/Button";

const MyBookingsDetails = () => {
  const dispatch = useDispatch<any>();
  const booking_view_data = useSelector(
    (state: any) => state.DashboardBookingViewDetailState,
  );
  const mark_as_complete = useSelector(
    (state: any) => state.BookingMarkAsCompletedState,
  );
  const dashboard_booking_status_change = useSelector(
    (state: any) => state.DashboardBookingStatusChangeBookingState,
  );
  const [totalMoney, setTotalMoney] = useState(0);

  const [bookingData, setbookingData]: any = useState([]);
  const [isImageLoading, setImageLoading] = useState(false);
  const [cancelStatus, setCancelStatus] = useState(false);
  const [selectedData, setSelectedData]: any = useState(null);
  const location = useLocation();
  const pathname = location.pathname;
  const pathSegments = pathname.split("/");

  const user_id = decodeID(pathSegments[2]);
  const booking_id = decodeID(pathSegments[3]);
  const service_id = decodeID(pathSegments[4]);

  useEffect(() => {
    dispatch(
      DashboardBookingViewDetailAction({
        user_id: user_id,
        booking_id: booking_id,
        service_id: service_id,
      }),
    );
  }, []);

  useEffect(() => {
    if (booking_view_data?.status) {
      setbookingData(booking_view_data?.data?.data);
    }
  }, [booking_view_data]);

  useEffect(() => {
    const totalPrice = bookingData?.booking_details2?.reduce(
      (total: number, data: any) => {
        return (
          total + (data?.parent_details?.price ? data.parent_details.price : 0)
        );
      },
      0,
    );

    setTotalMoney(totalPrice);
  }, [bookingData?.booking_details2]);

  useEffect(() => {
    if (mark_as_complete?.status == true) {
      dispatch(
        DashboardBookingViewDetailAction({
          user_id: user_id,
          booking_id: booking_id,
          service_id: service_id,
        }),
      );
    }
  }, [mark_as_complete]);

  useEffect(() => {
    if (dashboard_booking_status_change?.status) {
      dispatch(
        DashboardBookingViewDetailAction({
          user_id: user_id,
          booking_id: booking_id,
          service_id: service_id,
        }),
      );
      dispatch(DashboardBookingChangeUpdateAction("RESET"));
    }
  }, [dashboard_booking_status_change]);

  const bookingDetail = bookingData?.booking_details?.[0];

  const handleRestoreUpcoming = () => {
    dispatch(
      DashboardBookingChangeUpdateAction({
        booking_id: booking_id,
        booking_status: "0",
        reason: "REASON MANAGE BOOKING",
        user_id: user_id,
        service_id: service_id,
      }),
    );
  };

  const handleCancelFromNoShow = () => {
    setSelectedData({
      tabName: "2",
      user_id,
      booking_id,
      service_id,
      booking_service_id: bookingDetail?.id,
    });
    setCancelStatus(true);
  };

  return (
    <>
      {booking_view_data?.data?.data ? (
        <div className="col-lg-9 bookingDetails">
          {booking_view_data?.loading || mark_as_complete?.status == true ? (
            <Spinner />
          ) : (
            ""
          )}
          <div className="dashboard bg-white">
            <div className="dashboardTop d-sm-flex align-items-center">
              <h2>
                <button
                  type="button"
                  className="btn mobileMenu p-1 d-lg-none"
                  onClick={() => {
                    sidebarOpen();
                  }}
                >
                  <span className="icon-menu-right"></span>
                </button>{" "}
                <FormattedMessage id="My_Bookings" />
              </h2>
              <Breadcrumb items={[]} />
            </div>
            <div className="dashboarcard">
              <div className="bookingTop">
                <div className="bookingTopleft">
                  <figure>
                    <img
                      src={
                        bookingData?.profile_pic
                          ? bookingData?.profile_pic
                          : ImageContainer?.USERIMAGE
                      }
                      onError={(e: any) =>
                        (e.target.src = ImageContainer?.USERIMAGE)
                      }
                    />
                  </figure>
                  <div className="bookingTOPuser">
                    <h6>{capitalizeFirstLetter(bookingData?.name)}</h6>
                    <div>
                      #{bookingData?.booking_details?.[0]?.booking_id}{" "}
                      <span></span>{" "}
                      {bookingData?.dob
                        ? `Age ${getAgeFromDOB(bookingData?.dob)}`
                        : null}{" "}
                      <span></span>
                      {bookingData?.gender}
                    </div>
                    {/* <div className="orderstatus upcoming"><span><i className="icon-upcoming"></i></span>Upcoming</div>  */}

                    {/* {bookingData?.booking_details?.[0]?.status == 0 ||
                    bookingData?.booking_details?.[0]?.status == 4 ? (
                      <div className="orderstatus upcoming">
                        <span>
                          <i className="icon-upcoming"></i>
                        </span>{" "}
                        <FormattedMessage id="Upcoming" />
                      </div>
                    ) : bookingData?.booking_details?.[0]?.status == 1 ? (
                      <div className="orderstatus Completed">
                        <span>
                          <i className="icon-upcoming"></i>
                        </span>{" "}
                        <FormattedMessage id="Completed" />
                      </div>
                    ) : (
                      <div className="orderstatus Cancelled">
                        <span>
                          <i className="icon-upcoming"></i>
                        </span>{" "}
                        <FormattedMessage id="Cancelled" />
                      </div>
                    )} */}

                    {bookingData?.booking_details?.[0]?.status == 0 ||
                    bookingData?.booking_details?.[0]?.status == 4 ? (
                      <div className="orderstatus upcoming">
                        <span>
                          <i className="icon-upcoming"></i>
                        </span>
                        {<FormattedMessage id="Upcoming" />}
                      </div>
                    ) : bookingData?.booking_details?.[0]?.status == 1 ? (
                      <div className="orderstatus Completed">
                        <span>
                          <i className="icon-upcoming"></i>
                        </span>
                        {<FormattedMessage id="Completed" />}
                      </div>
                    ) : bookingData?.booking_details?.[0]?.status == 2 ? (
                      <div className="orderstatus Cancelled">
                        <span>
                          <i className="icon-upcoming"></i>
                        </span>
                        {<FormattedMessage id="Cancelled" />}
                      </div>
                    ) : bookingData?.booking_details?.[0]?.status == 3 ? (
                      <div className="orderstatus Cancelled">
                        <span>
                          <i className="icon-upcoming"></i>
                        </span>
                        {<FormattedMessage id="No_Shown_upon" />}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="bookingTopRight userAction">
                  {/* <div><button type="button" title={<a href="mailto:someone@example.com">Send email</a>} className="btn btnroundIcon"><i className="icon-mail"></i></button>{bookingData?.email} </div> */}
                  {/* <div>
                                            <button
                                                type="button"
                                                data-tip
                                                data-for="emailTooltip"
                                                className="btn btnroundIcon"
                                            >
                                                <i className="icon-mail"></i>
                                            </button>
                                            <ReactTooltip id="emailTooltip" place="top" effect="solid">
                                                <a href={`mailto:${bookingData?.email}`}>Send email</a>
                                            </ReactTooltip>
                                            {bookingData?.email}
                                        </div> */}
                  <div>
                    <a
                      href={`mailto:${bookingData?.email}`}
                      className="btn btnroundIcon"
                      title={bookingData?.email ? bookingData?.email : "email"}
                    >
                      {" "}
                      <i className="icon-mail"></i>
                    </a>
                  </div>
                  {/* <div><button type="button" title={bookingData?.email ? bookingData?.email : 'email'} className="btn btnroundIcon"><i className="icon-mail"></i></button> {bookingData?.email} </div> */}
                  <div>
                    <button
                      type="button"
                      className="btn btnroundIcon ms-1 ms-sm-2"
                      title={
                        bookingData?.phone_number
                          ? `+${bookingData?.phone_country_code} ${bookingData?.phone_number}`
                          : ""
                      }
                      onClick={() => {
                        if (bookingData?.phone_number) {
                          const phone = `+${bookingData?.phone_country_code?.replace(/^\++/, "")}${bookingData?.phone_number}`;
                          window.location.href = `tel:${phone}`;
                        }
                      }}
                    >
                      <i className="icon-call-1"></i>
                    </button>
                    {bookingData?.phone_country_code &&
                      `+${bookingData?.phone_country_code.replace(/^\++/, "")}` +
                        " " +
                        bookingData?.phone_number}
                  </div>
                </div>
              </div>
              <div className="row bookingDetailsTime">
                <div className="col-lg-7">
                  <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
                    <h6>
                      {" "}
                      <FormattedMessage id="Service" />
                    </h6>
                    {/* <button type='button' className='btn btnOUtlinePrimary btn-sm'>Assign to Staff Member</button> */}
                  </div>
                  <div className="card">
                    <div className="card-body">
                      <ul>
                        <>
                          <li>
                            <p className="listtitle">
                              {bookingData?.booking_details?.[0]
                                ?.service_details?.name
                                ? capitalizeFirstLetter(
                                    bookingData?.booking_details?.[0]
                                      ?.service_details?.name,
                                  )
                                : "N/A"}{" "}
                              <b>
                                €{" "}
                                {bookingData?.booking_details?.[0]?.amount
                                  ? bookingData?.booking_details?.[0]?.amount
                                  : "00.00"}
                              </b>
                            </p>
                            <p className="timePRice">
                              <span>
                                <i className="icon-clock"></i>
                                {bookingData?.booking_details?.[0]
                                  ?.service_details?.duration
                                  ? formatTimeMinutes(
                                      bookingData?.booking_details?.[0]
                                        ?.service_details?.duration,
                                    )
                                  : "00.00"}{" "}
                              </span>
                            </p>
                            <div className="stafName">
                              <figure>
                                <img
                                  src={
                                    bookingData?.booking_details?.[0]
                                      ?.staff_details?.profile_pic
                                      ? bookingData?.booking_details?.[0]
                                          ?.staff_details?.profile_pic
                                      : ImageContainer?.USERIMAGE
                                  }
                                  onError={(e: any) =>
                                    (e.target.src = ImageContainer?.USERIMAGE)
                                  }
                                ></img>
                              </figure>
                              <p>
                                {bookingData?.booking_details?.[0]
                                  ?.staff_details?.owner_name
                                  ? capitalizeFirstLetter(
                                      bookingData?.booking_details?.[0]
                                        ?.staff_details?.owner_name,
                                    )
                                  : "N/A"}
                              </p>
                            </div>
                          </li>

                          {bookingData?.booking_details2?.map((data: any) => {
                            return (
                              <>
                                {data?.parent_details && (
                                  <>
                                    <li>
                                      <p className="listtitle">
                                        {data?.parent_details?.name
                                          ? capitalizeFirstLetter(
                                              data?.parent_details?.name,
                                            )
                                          : "N/A"}{" "}
                                        <b>
                                          €{" "}
                                          {data?.parent_details?.price
                                            ? data?.parent_details?.price
                                            : "00.00"}
                                        </b>
                                      </p>
                                      <p className="timePRice">
                                        <span>
                                          <i className="icon-clock"></i>
                                          {data?.parent_details?.duration
                                            ? data?.parent_details?.duration
                                            : "00.00"}{" "}
                                          Mins
                                        </span>
                                      </p>
                                      <div className="stafName">
                                        <figure>
                                          <img
                                            src={
                                              bookingData?.booking_details?.[0]
                                                ?.staff_details?.profile_pic
                                                ? bookingData
                                                    ?.booking_details?.[0]
                                                    ?.staff_details?.profile_pic
                                                : ImageContainer?.USERIMAGE
                                            }
                                          ></img>
                                        </figure>
                                        <p>
                                          {bookingData?.booking_details?.[0]
                                            ?.staff_details?.owner_name
                                            ? capitalizeFirstLetter(
                                                bookingData
                                                  ?.booking_details?.[0]
                                                  ?.staff_details?.owner_name,
                                              )
                                            : "N/A"}
                                        </p>
                                      </div>
                                    </li>
                                  </>
                                )}
                              </>
                            );
                          })}
                        </>
                      </ul>
                    </div>
                  </div>

                  <h6 className="my-3">
                    {" "}
                    <FormattedMessage id="Payment_Information" />
                  </h6>
                  <div className="card">
                    <div className="card-body serVicePage">
                      <ul>
                        <li>
                          {" "}
                          <FormattedMessage id="Service" /> 1{" "}
                          <span>
                            €{" "}
                            {bookingData?.booking_details?.[0]?.amount
                              ? bookingData?.booking_details?.[0]?.amount
                              : "00"}
                            .00
                          </span>
                        </li>

                        {bookingData?.booking_details2?.map(
                          (data: any, index: any) => {
                            return (
                              <>
                                {data?.parent_details && (
                                  <>
                                    <li>
                                      {" "}
                                      <FormattedMessage id="Service" />{" "}
                                      {index + 2}
                                      <span>
                                        €{" "}
                                        {data?.parent_details?.price
                                          ? data?.parent_details?.price
                                          : "00"}
                                        .00
                                      </span>
                                    </li>
                                  </>
                                )}
                              </>
                            );
                          },
                        )}
                        {/* <li className='total'> <FormattedMessage id="Total" /> <span>€{bookingData?.booking_details?.[0]?.booking_detail?.total_amount ? (bookingData?.booking_details?.[0]?.booking_detail?.total_amount + ".00") : "00.00"}</span></li> */}
                        <li className="total">
                          {" "}
                          <FormattedMessage id="Total" />{" "}
                          <span>
                            €
                            {bookingData?.booking_details?.[0]?.amount ||
                            totalMoney
                              ? totalMoney +
                                Number(
                                  bookingData?.booking_details?.[0]?.amount,
                                ) +
                                ".00"
                              : "00.00"}
                          </span>
                        </li>
                        {/* <li className='total'> <FormattedMessage id="Total" /> <span>€ {bookingData?.booking_details?.[0]?.booking_detail?.total_amount ? (Number(bookingData?.booking_details?.[0]?.booking_detail?.total_amount) + Number(totalMoney)) : "00"}.00</span></li> */}
                      </ul>
                    </div>
                  </div>
                  <h6 className="my-3">
                    {" "}
                    <FormattedMessage id="Payment_note" />
                  </h6>

                  <div className="card">
                    <div className="card-body serVicePage">
                      <ul>
                        {bookingData?.booking_details?.[0]?.payment_note && (
                          <li>
                            {" "}
                            <span>
                              {" "}
                              {bookingData?.booking_details?.[0]?.payment_note
                                ? bookingData?.booking_details?.[0]
                                    ?.payment_note
                                : ""}
                            </span>
                          </li>
                        )}
                        {bookingData?.booking_details?.[0]?.reason_type && (
                          <li>
                            {" "}
                            <span>
                              {" "}
                              {bookingData?.booking_details?.[0]?.reason_type
                                ? bookingData?.booking_details?.[0]?.reason_type
                                : ""}
                            </span>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 bookedCard">
                  <h6 className="mb-3">
                    {" "}
                    <FormattedMessage id="Date_Time_of_Appointment" />
                  </h6>
                  <div className="card">
                    <div className="card-body">
                      <ul>
                        {/* {
                                                        bookingData?.booking_detail?.booking_service_details?.length > 0 && bookingData?.booking_detail?.booking_service_details?.map((item: any, index: any) => {
                                                            return ( */}
                        <>
                          <li>
                            <p className="listtitle">
                              {" "}
                              <FormattedMessage id="Booked_for" />:
                            </p>
                            {/* {moment(bookingData?.booking_details?.[0]?.slot_st).format("HH:mm:ss")} - {moment(bookingData?.booking_details?.[0]?.slot_et).format("HH:mm:ss")} */}
                            <p className="timePRice">
                              {" "}
                              {bookingData?.booking_details
                                ? moment
                                    .utc(
                                      bookingData?.booking_details?.[0]
                                        ?.slot_st,
                                    )
                                    .local()
                                    .locale("en")
                                    .format("dddd, D MMM YYYY")
                                : ""}{" "}
                              |{" "}
                              {LocalTimeFormat(
                                bookingData?.booking_details?.[0]?.slot_st,
                              )}{" "}
                              -{" "}
                              {LocalTimeFormat(
                                bookingData?.booking_details?.[0]?.slot_et,
                              )}
                              {/* {moment(bookingData?.booking_details?.[0]?.slot_st).format("HH:mm:ss")} - {bookingData?.booking_details?.[0]?.slot_et} */}
                            </p>
                            <p className="listtitle">
                              {" "}
                              <FormattedMessage id="Booked_on" />:
                            </p>
                            <p className="timePRice">
                              {" "}
                              {bookingData?.booking_details
                                ? moment
                                    .utc(
                                      bookingData?.booking_details?.[0]
                                        ?.created_at,
                                    )
                                    .local()
                                    .locale("en")
                                    .format("dddd, D MMM YYYY")
                                : ""}{" "}
                              |{" "}
                              {LocalTimeFormat(
                                bookingData?.booking_details?.[0]?.created_at,
                              )}
                            </p>
                          </li>
                        </>
                      </ul>
                    </div>
                  </div>
                  {bookingData?.booking_details?.[0]?.booking_detail
                    ?.remark && (
                    <>
                      <h6 className="my-3">
                        {" "}
                        <FormattedMessage id="Remarks" />
                      </h6>
                      <div className="card">
                        <div className="card-body">
                          {
                            bookingData?.booking_details?.[0]?.booking_detail
                              ?.remark
                          }
                        </div>
                        {/* <div className='card-body'>{bookingData?.booking_detail?.remark}</div> */}
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="text-center text-md-start mt-4 mt-md-5 d-flex flex-column flex-md-row gap-2 justify-content-center justify-content-md-start">
                {bookingData?.booking_details?.[0]?.status == 0 ? (
                  <button
                    type="button"
                    className="btn btn-fill"
                    data-bs-toggle="modal"
                    data-bs-target="#MarkToCompleted"
                  >
                    {" "}
                    <FormattedMessage id="Mark_as_Completed" />
                  </button>
                ) : bookingData?.booking_details?.[0]?.status == 3 ? (
                  <>
                    <Button
                      text={
                        (
                          <FormattedMessage id="restore_upcoming" />
                        ) as any
                      }
                      type="button"
                      className="btn btn-sm-outline"
                      onClick={handleRestoreUpcoming}
                    />
                    <button
                      type="button"
                      className="btn btn-sm-outline"
                      onClick={handleCancelFromNoShow}
                      data-bs-toggle="modal"
                      data-bs-target="#cancelReason"
                    >
                      <FormattedMessage id="cancel_booking" />
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm-outline"
                      data-bs-toggle="modal"
                      data-bs-target="#MarkToCompleted"
                    >
                      <FormattedMessage id="mark_completed" />
                    </button>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="col-lg-9 bookingDetails">
          <div className="dashboard bg-white">
            <div className="dashboardTop d-sm-flex align-items-center">
              <h2>
                <button type="button" className="btn mobileMenu p-1 d-lg-none">
                  <span className="icon-menu-right"></span>
                </button>{" "}
                <FormattedMessage id="My_Bookings" />
              </h2>
              <Breadcrumb items={[]} />
            </div>
            <div className="dashboarcard">
              <div className="bookingTop">
                <div className="bookingTopleft">
                  {booking_view_data?.loading ? <Spinner /> : ""}
                  <p>
                    {" "}
                    <FormattedMessage id="do_not_found" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <MarkCompleted serviceId={bookingData} />
      <CancelReason
        status={cancelStatus}
        setCancelStatus={setCancelStatus}
        payload={selectedData}
      />
    </>
  );
};

export default MyBookingsDetails;
